export default "__VITE_ASSET__E9fY7ibb__"